import { render, staticRenderFns } from "./PainerMsgSever.vue?vue&type=template&id=6b2caf6e&scoped=true"
import script from "./PainerMsgSever.vue?vue&type=script&lang=js"
export * from "./PainerMsgSever.vue?vue&type=script&lang=js"
import style0 from "./PainerMsgSever.vue?vue&type=style&index=0&id=6b2caf6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2caf6e",
  null
  
)

export default component.exports